import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchHigherEducation, deactivateEducation } from '../../../../redux/actions/action';
import Table from '../../../../components/tableComponents/Table';

const EducationList = () => {
  const dispatch = useDispatch();
  const higherEducation = useSelector((state) => state.higherEducation.higherEducation);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchHigherEducation());
  }, [dispatch]);

  const formatDate = (date) => {
    const dateObject = new Date(date);
    const utcDate = new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate(), dateObject.getUTCHours(), dateObject.getUTCMinutes(), dateObject.getUTCSeconds());
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(utcDate);
  };
  
  const handleEdit = (degreeId) => {
    navigate(`/updateEducation/${degreeId}`);
  };

  const handleDeactivate = (degreeId) => {
    dispatch(deactivateEducation(degreeId));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Education ID',
        accessor: 'degree_id',
      },
      {
        Header: 'Higher Education',
        accessor: 'degree_name',
      },
      {
        Header: 'Creation Date',
        accessor: 'creation_date',
        Cell: ({ value }) => {
          if (!value) {
            return ''; 
          }
          const date = new Date(value);
          return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        },
      },
      {
        Header: 'Actions',
        Cell: ({ row }) => (
          <>
          {row.original.status === 0 ? (
            <button onClick={() => handleEdit(row.original.degree_id)} className="font-semibold text-base px-4 py-2 mr-2 rounded-lg bg-white-500 text-black hover:bg-blue-600">
              Edit
            </button>
          ) : (
            <button disabled className="font-semibold text-base px-4 py-2 mr-2 rounded-lg bg-white-500 text-black opacity-50 cursor-not-allowed">
            Edit
            </button>
          )}
          <button onClick={() => handleDeactivate(row.original.degree_id)} className="font-semibold text-base px-6 py-2 rounded-lg bg-white-500 text-black hover:bg-blue-600">
            {row.original.status === 1 ? 'Activate' : 'Deactivate'}
          </button>
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className="text-white lg:ml-5 lg:mt-[-135px] xl:ml-[225px] xl:mt-[-200px] 2xl:w-[900px]">
      <Table columns={columns} 
      data={higherEducation} 
      rowClassName={(row) => (row.original.status === 1 ? 'bg-white text-black' : '')} 
      /> 
    </div>
  );
};

export default EducationList;
